import { useNode } from '@craftjs/core';
import { useCallback } from 'react';

import { useIsBlockEditorEditMode } from '../../BlockEditor.context';
import { BLOCK_DISPLAY_NAMES } from '../../blockEditor.types';
import { EditableComponentWrapper } from '../../EditableComponentWrapper/EditableComponentWrapper';
import {
  PresentationListItem,
  PresentationListItemProps,
} from './PresentationListItem';
import { PresentationListItemSettings } from './PresentationListItemSettings';

export function EditablePresentationListItem(props: PresentationListItemProps) {
  const {
    connectors: { connect, drag },
  } = useNode();
  const isEditMode = useIsBlockEditorEditMode();

  const attachRef = useCallback(
    (ref: HTMLDivElement | null) => {
      if (ref && isEditMode) {
        connect(drag(ref));
      }
    },
    [connect, drag, isEditMode]
  );

  return (
    <EditableComponentWrapper>
      <PresentationListItem {...props} ref={attachRef} />
    </EditableComponentWrapper>
  );
}

EditablePresentationListItem.craft = {
  displayName: BLOCK_DISPLAY_NAMES.PresentationListItem,
  props: {
    title: 'List item title',
    description: 'List item description',
    iconType: 'check',
    iconColor: 'PRIMARY',
  },
  related: {
    settings: PresentationListItemSettings,
  },
};
